// import React from 'react';
import React, {useState,useEffect} from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import * as Common from '../../common';

//画像の読み込み
import Logo from '../../assets/images/logo.png';
import IconView from '../../assets/images/ico_view.svg';

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

//TSX
function Login() {

    //ページタイトルを変更
    document.title = `ログイン | ${Common.SITE_NAME}`;

    //もしログイン画面を表示したときにすでにログインしていた場合
    useEffect(() => {
        /**
         * tokenを取得
         */
        const token=Common.getCookie('cookieToken')

        //ログインしていた場合
        if(token!=='not found'){
            //会員情報取得関数を実行(完了後に強制ログアウトが働いてページ遷移)
            getMemberInfo(token)
        }
    }, [])

    /**
     * エラー文言
     */
    const [errorText,setErrorText]=useState<String>('')
    
    /**
     * パスワードが見えているかどうか
     */
    const [isPasswordShow,changePasswordState]=useState<boolean>(false)

    /**
     * ログイン情報
     */
    const [loginInfo, setLoginInfo] = useState<Common.typeLogin>({
        login_id:"",
        password:"",
    })

    const history = useHistory();

    /**
     * ページ遷移関数
     */
    const pageTransition=(path:string)=>{
        history.push(path)
    }

    /**
     * ログイン処理
     */
    const login=(e:React.FormEvent)=>{
        //submit処理を取り消し
        e.preventDefault();

        //エラーとなる正規表現パターン
        const correctPattern=new RegExp('\\S')
        
        if(//IDもパスワードもOKのとき
            loginInfo.login_id.match(correctPattern)&&
            loginInfo.password.match(correctPattern)
        ){
            //axiosでAPI呼び出し
            axios.post(`${Common.API_DOMAIN()}/api/api/v1/auth/login`,loginInfo)
            .then((response:any)=>{
                if(response.message){
                    setErrorText(response.message)
                }else{

                    //エラーメッセージを削除
                    setErrorText('')

                    const token=response.data.access_token;
                    //tokenをcookieに入れる
                    document.cookie = "cookieToken=" + token + ";max-age=" + Common.LOGIN_EXPIRE_TIME

                    //会員情報取得
                    getMemberInfo(token)
                }
            })
            .catch((error)=>{
                if(error.response.status===404){
                    //エラーメッセージを表示
                    setErrorText('メールアドレス(ID)またはパスワードが違います。')
                }
            })
        }else if(
            //IDがOKでパスワードがNGのとき
            loginInfo.login_id.match(correctPattern)&&
            !loginInfo.password.match(correctPattern)
        ){
            //エラーメッセージを表示
            setErrorText('パスワードを入力してください')
        }else if(
            //IDがNGでパスワードがOKのとき
            !loginInfo.login_id.match(correctPattern)&&
            loginInfo.password.match(correctPattern)
        ){
            //エラーメッセージを表示
            setErrorText('メールアドレス(ID)を入力してください')
        }else{
            //IDもパスワードもNGのとき
            setErrorText('メールアドレス(ID)・パスワードを入力してください')
        }
    }

    /**
     * 会員情報取得
     */
    const getMemberInfo=(token:any)=>{
        //axiosでAPI呼び出し
        axios.get(`${Common.API_DOMAIN()}/api/api/v1/auth/me`,{
            headers:{
                Authorization: `Bearer ${token}`
            }
        })
        .then((response)=>{

            //ランダム文字列作成
            const getRandomString=(num:Number)=>{

                // 生成する文字列に含める文字セット
                var c = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

                var cl = c.length;
                var r = "";
                for(var i=0; i<num; i++){
                r += c[Math.floor(Math.random()*cl)];
                }
                return r;
            }

            //hostnameを取得、もしなければ生成してCookieに登録
            let hostName=Common.getCookie('hostName')
            if(hostName==='not found'){
                const hostNameTemp=getRandomString(16)
                document.cookie = "hostName=" + hostNameTemp + ";max-age=" + 365*60*60*64 //1年間保持。Cookieは無期限に設定することができないため。
                hostName=hostNameTemp
            }

            /**
             * 他のログイン中の端末のデータ
             */
            const otherDevices=response.data.s_loging_users.filter((value:any)=>{
                return value.host_name!==hostName
            })

            //もし自分以外の端末がログインしていたら
            if(otherDevices.length>0){
                //強制ログインしますか？のメッセージを出す
                if(window.confirm(`端末「${otherDevices[0].host_name}」がログイン中です。\n強制ログインしますか？`)){
                    //「はい」を押すと、強制ログアウト
                    logoutOtherDevice(
                        token,hostName
                    )
                }//「いいえ」を押すと、何も起こらない
            }else{
                //自分以外の端末がログインしていない場合、案件一覧画面に遷移
                pageTransition('/project')
            }

            
        })
        .catch((error)=>{
            console.error(error)
        })
    }

    /**
     * 他端末をログアウトさせる
     */
    const logoutOtherDevice=(
        token:any,hostName:any
    )=>{

        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        axios.post(`${Common.API_DOMAIN()}/api/api/v1/auth/refresh`,
            {
                host_name:hostName
            },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then((response)=>{

            const tokenNew=response.data.token;
            //tokenをcookieに入れる
            document.cookie = "cookieToken=" + tokenNew + ";max-age=" + Common.LOGIN_EXPIRE_TIME

            pageTransition('/project')
        })
        .catch((error)=>{
            console.error(error)
        })

        
    }
        
    //マークアップ
    return(
        <section className="login content">
            <div className="login__inner content__inner">
                <div className="login__ttl">
                    <h1 className="login__ttl-en">
                        <img src={Logo} alt="Goolip" />
                    </h1>
                    <div className="login__ttl-ja">
                        ログイン
                    </div>
                </div>
                <div className="login__body">
                    <form className="login__form" onSubmit={login}>
                        <div className="login__form__inner">
                            <dl className="login__item">
                                <dt className="login__item-ttl">
                                    メールアドレス（ID）
                                </dt>
                                <dd className="login__item-form">
                                    <input type="email" maxLength={40} className="login__item-form-input" onChange={(e) => {setLoginInfo({ ...loginInfo, login_id: e.target.value });}}/>
                                </dd>
                            </dl>
                            <dl className="login__item">
                                <dt className="login__item-ttl">
                                    パスワード
                                </dt>
                                <dd className="login__item-form" id="login__password-wrap" data-is-password-show={isPasswordShow}>
                                    <input type={isPasswordShow?'text':'password'} maxLength={256} className="login__item-form-input login__item-form-input--password" id="login__password" onChange={(e) => {setLoginInfo({ ...loginInfo, password: e.target.value });}}/>
                                    <button type="button" className="login__item-form-eye" id="js-password-toggle" onClick={()=>isPasswordShow?changePasswordState(false):changePasswordState(true)}>
                                        <img src={IconView} alt="パスワード表示/非表示" />
                                    </button>
                                </dd>
                            </dl>
                            <div className="login__submit">
                                <input type="submit" value="ログインする" className="login__submit-btn" tabIndex={0} />
                            </div>
                            { errorText!==''&&errorText!==null&&
                                (
                                    <div className="login__error">
                                        {errorText}
                                    </div>
                                )
                            }
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
}


export default Login;
